export enum PriceFrequency {
  PCM = 0,
  PW = 1,
  PQ = 2,
  PA = 3,
  PN = 4,
  PPPW = 5,
}
